export default {
  salesConsultants: [],
  salesConsultant: {},
};
